export const INVALID_SOLUTION_DEFINITION = 'INVALID_SOLUTION_DEFINITION'


// WEBPACK FOOTER //
// ./src/App/Admin/Solutions/constants.js